










































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import StockList from "@/components/stockList/index.vue";
import StockNoData from "../stockNoData/index.vue";
import Segment from "@/components/segment/index.vue";
import { tabsListListed } from "../../common/config";
import { renderZhongqianData } from "../../common/sourceConfig";
const win: any = window;
const { hxmClickStat } = win;

@Component({
  components: {
    StockList,
    Segment,
    StockNoData
  }
})
export default class StockListTable extends Vue {
  @Prop() private readonly data!: any; // 渲染的数据
  @Prop() private readonly config!: any; // 组件配置
  @Prop() private readonly jumpConfig!: any; // 跳转二级页配置, type字段用不上了，改成表示A股还是新三板
  @Prop() private readonly maidian!: any; // 埋点配置

  private tabsList: any = tabsListListed; // 渲染tab的数据
  private selectTab: any = tabsListListed[0]; // 当前选中的tab
  private dataListed: any = null;
  private compFid: any = null;
  private maidianId = ".xg";
  private configComp: any = null;
  // 监听数据改变
  @Watch("data", { immediate: false, deep: true })
  getNewData(newVal: any) {
    if (this.compFid !== this.jumpConfig.module) {
      this.selectTab = tabsListListed[0];
      this.compFid = this.jumpConfig.module;
    }
    // 初始化选中tab
    this.dataListed = this.initData(this.data, this.selectTab);
  }

  private created() {
    this.compFid = this.jumpConfig.module;
    this.configComp = JSON.parse(JSON.stringify(this.config));
    this.dataListed = this.initData(this.data, this.selectTab);
  }

  /**
   * 初始化数据
   */
  private initData(data: any, selectTab: any) {
    if (selectTab.index === 0 && data && data.stock) {
      if(this.jumpConfig.module === 'wait_listing'){
        renderZhongqianData(data.stock.titleData.dataList,this);
      }
      return {
        titleData: data.stock.titleData,
        listData: data.stock.listData
      };
    }
    if (selectTab.index === 1 && data && data.bond) {
      if(this.jumpConfig.module === 'wait_listing'){
        renderZhongqianData(data.bond.titleData.dataList,this);
      }
      return {
        titleData: data.bond.titleData,
        listData: data.bond.listData
      };
    }
    return {
      titleData: {},
      listData: []
    };
  }

  private handleChange(item: any) {
    this.maidianId = item.index === 0 ? ".xg" : ".xz";
    this.configComp.noDataConfig.text =
      item.index === 0
        ? this.config.noDataConfig.text
        : this.config.noDataConfig.textBond;

    hxmClickStat(this.maidian + this.maidianId);


    this.$emit("changeType", item.name);
    this.selectTab = item;
  }

  // 是否显示组件函数显示无数据状态
  private isShowComp() {
    if (
      this.selectTab.index === 0 &&
      this.data &&
      this.data.stock &&
      this.data.stock.listData &&
      this.data.stock.listData.length > 0
    ) {
      return true;
    }
    if (
      this.selectTab.index === 1 &&
      this.data &&
      this.data.bond &&
      this.data.bond.listData &&
      this.data.bond.listData.length > 0
    ) {
      return true;
    }
    return false;
  }
}
